import { React, useState, Image } from "react";
import { sendPostRequest } from "../../Client/index.js";
import MobileFooter from "../../Components/MobileFooter";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import HeaderPreRegistration from "../../Components/HeaderPreRegistration";
import { usePreReg } from "../PreRegContext.js";

const PreRegistrationEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  //const { name, locationID, bookingReference } = location.state || {};

  const { contextPreReg, setContextPreReg } = usePreReg();

  const [email, setEmail] = useState("");

  const handleSubmit = async (values) => {
    if (!values.email || !email.includes("@")) {
      alert("Please enter a valid email address.");
      return;
    }

    const res = await sendPostRequest(`registration/lookup`, {
      email: values.email,
      bookingReference: contextPreReg,
    });

    if (res?.users?.length > 0) {
      navigate("/pre-registration/select-user", {
        state: {
          users: res.users,
          email: values.email,
          bookingReference: contextPreReg,
        },
      });
    } else {
      navigate("/pre-registration/confirm-details", {
        state: {
          email: values.email,
          bookingReference: contextPreReg,
        },
      });
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
      <HeaderPreRegistration bookingReference={contextPreReg} />

      <h1 className="text-3xl mt-6 text-center Kallisto_Bold">
        Enter your email address
      </h1>

      <div className="mt-6 flex justify-center mb-6 w-4/5 sm:w-2/5 mx-auto">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="bg-[#1f2644] rounded-md px-6 py-4 text-white text-lg w-full max-w-md font-kallisto focus:outline-none focus:ring-2 Kallisto_Bold  "
        />
      </div>

      <div className="flex flex-col sm:flex-row justify-center gap-4 w-4/5 sm:w-2/5 mx-auto">
        <button
          onClick={() => {
            handleSubmit({ email });
          }}
          className="bg-[#3F50F6] hover:bg-[#2d3fcc] py-4 px-8 rounded flex items-center justify-center w-full sm:w-[250px] gap-4"
        >
          <span className="text-white Kallisto_Bold font-bold whitespace-nowrap">
            Confirm
          </span>
        </button>
      </div>
    </div>
  );
};

export default PreRegistrationEmail;
